import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { type PopperPlacementType } from "~/common/mui";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";

export const InfoCircleV2 = ({
  content,
  placement = "bottom",
  iconSize = "medium",
  iconClassName,
}: {
  content: string;
  placement?: PopperPlacementType;
  iconSize?: "inherit" | "large" | "medium" | "small";
  iconClassName?: string;
}) => {
  return (
    <TooltipWithArrow title={content} placement={placement}>
      <InfoOutlinedIcon fontSize={iconSize} sx={{ cursor: "pointer" }} className={iconClassName} />
    </TooltipWithArrow>
  );
};
